<template>
    <div class="patent_bg">
		<div class="patent_title">长三角地区有效发明专利拥有情况</div>
		<div class="patent_chart">
			<div class="chart_left">
				<div class="chart_title">单位：千件</div>
				<div id="barChart3" style="width:100%;height:200px;"></div>
			</div>
			<dv-decoration-2 :reverse="true" style="width:5px;height:150px;" />
			<div class="chart_right">
				<div class="chart_title">万人有效量</div>
				<div id="barChart4" style="width:100%;height:200px;"></div>
			</div>
		</div>
	</div>
</template>
<script>
    export default {
        data(){
            return{}
        },
        mounted() {
        	
        },
        methods:{
			getData(list1,list2){
				this.drowChart3(list1);
				this.drowChart4(list2);
			},
        	drowChart3(list1) {
        		let myChart = this.$echarts.init(document.getElementById('barChart3'));
        		var names = list1.map(item =>item.name);
        		var values = list1.map(item =>item.value);
				var option = {
        			textStyle: {
        				color: '#fff',
        			},
        			tooltip: {
        				trigger: 'axis',
        				axisPointer: {
        					type: 'line',
        					lineStyle: {
        						color: 'red'
        					}
        				}
        			},
        			grid: {
        				left: '0',
        				right: '0',
        				top: '20%',
        				bottom: '0',
        				containLabel: true
        			},
        			legend: {
        				data: ["发明有效"],
        				left:'center',
        				top: 0,
        				textStyle: {
        					color:"rgba(255,255,255,0.8)"
        				},
        				itemWidth: 10,
        				itemHeight: 10,
        			},
        			color: [{
        				type: 'linear',
        				x: 0,
        				y: 0,
        				x2: 0,
        				y2: 1,
        				colorStops: [{
        						offset: 0,
        						color: '#00C4F2'
        					}, // 设置颜色渐变
        					{
        						offset: 1,
        						color: '#0088F3'
        					}
        				]
        			}, ],
        			xAxis: [{
        				type: 'category',
        				data:names,
        				axisTick: {
        					alignWithLabel: true
        				},
        				axisLabel: {
        					interval: 0, //数据过多时不间隔显示名称
        				},
        				axisLine: { //X轴坐标线隐藏
        					show: false,
        				},
        			}, ],
        			yAxis: [{
        				show: false, //Y轴坐标线隐藏
        				type: 'value',
        				axisLabel : {   //Y轴隐藏过后产生留白
        					formatter: function(){
        						return "";
        					}
        				}
        			}],
        			series: [{
        				name: '发明有效',
        				type: 'bar',
        				barWidth: '40%', //柱子粗细
        				label: { //显示数值
        					show: true,
        					position: 'outside',
        					color: '#fff'
        				},
        				data:values,
        			}]
        		};
        		myChart.setOption(option);				
        		window.addEventListener("resize", function() {
        			myChart.resize();
        		});
        	},
        	// 增幅
        	drowChart4(list2) {
        		let myChart = this.$echarts.init(document.getElementById('barChart4'));
        		var names = list2.map(item =>item.name);
        		var data = list2.map(item =>item.value);
        		var displayData = data.map(v =>Math.abs(v))  //处理过后的数据
        		var option =  {
        			legend: {
        				data: ["增幅"],
        				left:'center',
        				top: 0,
        				textStyle: {
        					color:"rgba(255,255,255,0.8)"
        				},
        				itemWidth: 10,
        				itemHeight: 10,
        			},
        		    grid: {
        		        top: '20%',
        		        left: '20%',
        		        right:'24%',
        		        bottom: '0'
        		    },
        		    xAxis: {
        		        type: 'value',
        		        min: 0,
        		        axisLine: {
        		            show: false,
        		        },
        		        splitLine: {
        		            show: false,
        		        },
        		        axisLabel: {
        		            show: false,
        		        },
        		        axisTick: {
        		            show: false,
        		        },
        		        max: 'dataMax',
        		    },
        		    yAxis: {
        		        type: 'category',
        		        inverse: true ,
        		        splitLine: {
        		            show: false,
        		        },
        		        axisLine: {
        		            show: false,
        		        },
        		        axisLabel: {
        		            show: true,
        		            align: 'left',
        		            color: '#B7E2F3',
        		            fontSize: 16,
        		            margin:60,
        		        },
        		        axisTick: {
        		            show: false
        		        },
        		        data:names,
        		    },
        			color: [{
        				type: 'linear',
        				x: 0,
        				y: 0,
        				x2: 0,
        				y2: 1,
        				colorStops: [{
        						offset: 0,
        						color: '#EDCB5D'
        					},
        					{
        						offset: 1,
        						color: '#EB6B20'
        					}
        				]
        			}, ],
        		    series: {
        		        name: '增幅',
        		        type: 'bar',
        		        barWidth:16,
        				data: displayData,
        		        label: {
        		            normal: {
        		                show: true,
        		                position: 'right',
        		                color: 'rgba(255,255,255,0.8)',
        		                fontSize: 16,
        						formatter:function(p){
        							return data[p.dataIndex] > 0 ? (p.value + '%') :('-'+ p.value) + '%'
        						}
        		            }
        		        },
        		    }
        		}
        		myChart.setOption(option);
        		window.addEventListener("resize", function() {
        		  myChart.resize();
        		});
        	},
        }
    }
</script>